import { createSlice } from '@reduxjs/toolkit';
import { Status } from '@api';

const DEFAULT_RETRY_COUNT = 4;

const _alert = {
    title: '',
    description: '',
    open: false,
    maintain: false,
};

const initialState = {
    gameLaunchStatus: Status.DEFAULT,
    gameExitStatus: Status.DEFAULT,
    retryCount: DEFAULT_RETRY_COUNT,
    /**
     * pathname before user launches game
     * to navigate back from ingame page
     */
    prevRoute: null,
    alert: _alert,
};

export const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        setGameLaunchStatus: (state, action) => {
            state.gameLaunchStatus = action.payload;
        },
        setGameExitStatus: (state, action) => {
            state.gameExitStatus = action.payload;
        },
        updateRetryCount: (state, action) => {
            state.retryCount = state.retryCount - 1;
        },
        resetRetryCount: (state, action) => {
            state.retryCount = DEFAULT_RETRY_COUNT;
        },
        setAlert: (state, action) => {
            state.alert = action.payload;
        },
        resetAlert: (state, action) => {
            state.alert = _alert;
        },
        setPrevRoute: (state, action) => {
            state.prevRoute = action.payload;
        },
    },
});

export const {
    setGameLaunchStatus,
    setGameExitStatus,
    updateRetryCount,
    resetRetryCount,
    setAlert,
    resetAlert,
    setPrevRoute,
} = gameSlice.actions;

export default gameSlice.reducer;
